import { bindData, byId, notyf } from "../utils"
import * as feather from "feather-icons"
import { userHasRole, getUser, createMission } from "../skylineApi"
import RadioList from "../views/radioList";

const root = byId("newMissionTemplate")

export default function index(app) {
  app.router.on('/missions/new', (match) => {
    if (!userHasRole(getUser(), "Flight Operator")) return app.router.navigate("/")

    console.log("Drawing the new mission route")
    const radioLists = []
    const newMissionE = root.content.firstElementChild.cloneNode(true)
    app.setContent(newMissionE, () => {
      for (const rl of radioLists) {
        rl.cleanup()
      }
      radioLists.splice(1, radioLists.length)
      cleanup()
    })

    // Other views
    radioLists.push(new RadioList(byId("airborne-selector"), { single: true, selectable: true, type: "ARS" }))
    radioLists.push(new RadioList(byId("new-grs-list"), { selectable: true, type: "GRS", filterReady: true, selectCallback: updateBounds(newMissionE) }))



    newMissionE.getElementsByTagName("button")[0].addEventListener("click", async () => {
      let bounds
      if (boundsRect) {
        bounds = {
          north: boundsRect._bounds.getNorth(),
          south: boundsRect._bounds.getSouth(),
          east: boundsRect._bounds.getEast(),
          west: boundsRect._bounds.getWest(),
        }
      }
      let mission = {
        name: newMissionE.querySelector("input").value,
        grses: [...newMissionE.querySelectorAll(".radio-picker .radio-selected")].map(e => e.device.id),
        ars: parseInt(newMissionE.querySelector(".airborne .selected .radioCard").dataset.did),
        bounds
      }
      console.log("Start for ", mission)
      try {
        let missionInfo = await createMission(mission)
        app.router.navigate(`/missions/${missionInfo.id}`)
      } catch (err) {
        notyf.error(err.message)
      }
    })
  })
}

let boundsRect
let drawLayer
let drawControl

function updateBounds(newMissionE) {
  drawLayer = new L.FeatureGroup().addTo(mymap)

  drawControl = new L.EditToolbar.Edit(mymap, {
    featureGroup: drawLayer,
  })

  const RADIO_DISTANCE_IN_METERS = 30 * 1609.344 // 30 miles in meters
  return () => {
    if (boundsRect) {
      boundsRect.removeFrom(drawLayer)
      boundsRect = null
    }
    let bounds = null
    const devices = [...newMissionE.querySelectorAll(".radio-picker .radio-selected")].map(e => e.device)
    if (devices.length <= 0) return
    for (const device of devices) {
      const extents = new L.LatLng(device.latitude, device.longitude).toBounds(RADIO_DISTANCE_IN_METERS)
      if (!bounds) {
        bounds = extents
      } else {
        bounds.extend(extents)
      }
    }
    mymap.fitBounds(bounds)
    boundsRect = new L.Rectangle(bounds, { color: "#ff7800", weight: 2, fill: 0.1, dashArray: "4 10", draggable: true })
    boundsRect.addTo(drawLayer)

    L.drawLocal.edit.handlers.edit.tooltip.subtext = undefined
    drawControl.enable()
  }
}

function cleanup() {
  if (boundsRect) boundsRect.removeFrom(drawLayer)
  if (drawLayer) drawLayer.removeFrom(mymap)
  if (drawControl) {
    drawControl.disable()

  }
}